import React, {useState} from "react";
import styled from 'styled-components';
import * as FaIcons from 'react-icons/fa';
import * as ImIcons from 'react-icons/im';
import {SideBarData} from "./SideBarData";
import SubMenu from "./SubMenu";
import Navbar from "../navbar/Navbar";
import './Sidebar.css';



const Nav = styled.div`
  background: #1b1d24;
  height: 80px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;


const NavIcon = styled.div`
  font-size: 2rem;
  cursor: pointer;
  display: flex; 
  padding-left: 15px;
  padding-right: 20px;
  justify-content: flex-start; 
  z-index: 30;
  position: fixed;
  elevation: above;
  height: 80px;
  align-items: center;
`;


const SideBarNav = styled.nav`
  background: #1b1d24;
  width: ${({sidebar})=>(sidebar?'250px': '60px')}; 
  height: 100vh;
  display: flex;
  justify-content: center; 
  position: fixed;top: 0; 
  transition: 250ms; 
  z-index: 20;
`;


const SideBarWrap = styled.nav`
  width: 100%; 
  overflow-y: auto
`;


export default function SideBar(){

	const [sidebar, setSidebar] = useState(false);

	const showSideBar=()=>{
		setSidebar(!sidebar);
	}

	return(
		<div>
			<Nav>
				{!sidebar?<NavIcon onClick={setSidebar} className='toHideOnMobile'>
					<ImIcons.ImMenu color='#fff'/>
				</NavIcon>:null}

				<Navbar/>
			</Nav>
			<SideBarNav sidebar={sidebar} className='toHideOnMobile'>
				<SideBarWrap>
					<NavIcon onClick={showSideBar}>
						{sidebar?<FaIcons.FaWindowClose color='#fff'/>:<span></span>}
					</NavIcon>
					<div className='marginHeight'>
					{SideBarData.map((item, index)=>{
						return <SubMenu item={item} key={index} isOpened={sidebar} closeMenu={showSideBar}/>
					})}
					</div>
				</SideBarWrap>
			</SideBarNav>
		</div>
	);
}